import { RiAlertLine, RiCheckLine, RiCloseCircleLine, RiFileCopyLine } from "react-icons/ri";

export type FactTone = "warn" | "error" | "dup" | "ready";

export interface Fact {
  tone: FactTone;
  text: string;
}

const ICONS: Record<FactTone, JSX.Element> = {
  warn: <RiAlertLine size={15} aria-hidden="true" />,
  error: <RiCloseCircleLine size={15} aria-hidden="true" />,
  dup: <RiFileCopyLine size={15} aria-hidden="true" />,
  ready: <RiCheckLine size={15} aria-hidden="true" />,
};

const TONES: Record<FactTone, string> = {
  warn: "text-amber-600",
  error: "text-red-600",
  dup: "text-orange-600",
  ready: "text-emerald-600",
};

/**
 * The consequences of a confirm, stated inside the dialog.
 *
 * A dialog covers the screen it was launched from, so anything the decision depends on
 * has to travel with it — most of all the fact that photos are about to overwrite ones
 * already in storage, which is otherwise only visible on the page underneath.
 */
export default function ConfirmFacts({ facts }: { facts: Fact[] }) {
  if (facts.length === 0) return null;
  return (
    <ul className="mt-3 space-y-1.5 text-left">
      {facts.map((f) => (
        <li key={f.text} className="flex items-start gap-2">
          <span className={`mt-0.5 shrink-0 ${TONES[f.tone]}`}>{ICONS[f.tone]}</span>
          <span className="text-sm leading-6 text-gray-700">{f.text}</span>
        </li>
      ))}
    </ul>
  );
}
